/*
  File: src/api/vendors.js
  Purpose: Vendors API client with helpers (list, create, getById, remove)
*/
import { apiClient } from '../auth/api';

export const VendorsAPI = {
    async list({ name, limit = 50, offset = 0 } = {}) {
        const params = {};
        if (name != null && String(name).trim() !== '') params.name = name;
        if (limit != null) params.limit = limit;
        if (offset != null) params.offset = offset;
        const { data } = await apiClient.get('/vendors', { params });
        return data;
    },

    async create(payload) {
        const { data } = await apiClient.post('/vendors', payload);
        return data;
    },

    async getById(vendorId) {
        const { data } = await apiClient.get(`/vendors/${vendorId}`);
        return data;
    },

    async remove(vendorId) {
        const { data } = await apiClient.delete(`/vendors/${vendorId}`);
        return data;
    }
};

export default VendorsAPI;


